import React from "react";
import { useAppContext } from "../../context/appContext";
import Graphs from "../../components/Reports/Graphs";
import Controls from "../../components/Reports/Controls";
import EmailReportForm from "../../components/EmailReportForm";

function BusinessReports() {
  const { showReportForm } = useAppContext();

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="page">
      {/* ----- Reports ------ */}
      <div className="group whole business-reports">
        <form className="form" onSubmit={handleSubmit}>
          <h3>Reports</h3>
          <div className="form-center">
            {/* Report Selector and Controls */}
            <Controls />

            {/* Report Graph */}
            <Graphs />
          </div>
        </form>
      </div>

      {/* ----- Email/ Report Confirmation Modal ------ */}
      <div className={showReportForm ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <EmailReportForm />
        </div>
      </div>
    </div>
  );
}
export default BusinessReports;
